import React, { useState } from "react";
import PropTypes from "prop-types";

import { Button, Popover, Badge, Modal, Timeline } from "antd";
import { FetchStatus, useFetchHistory } from "./use-fetch-history";

import { format } from "../../../../../utils/DateFormater";
import { format as formatCurrency } from "../../../../../utils/MoneyFormater";

import "./styles.css";

export const ValueHistory = ({ id_parcela, parcela_id, visible, onCancel }) => {
  const [isOpen, setIsOpen] = useState(false);
  const parcelaId = id_parcela || parcela_id;
  const { data, status } = useFetchHistory(parcelaId);

  const isControlled = typeof visible === "boolean";
  const open = isControlled ? visible : isOpen;

  const handleOpen = () => {
    if (isControlled) return;
    setIsOpen(true);
  };

  const handleClose = () => {
    if (isControlled) {
      onCancel();
    } else {
      setIsOpen(false);
    }
  };

  const isSuccess = status === FetchStatus.SUCCESS;
  const isError = status === FetchStatus.ERROR;

  return (
    <div className="value_history__container">
      {!isControlled && (
        <Badge
          count={data ? data.length : 0}
          overflowCount={9}
          offset={[2, -2]}
          style={{
            backgroundColor: "#fff",
            color: "#f5222d",
            boxShadow: "0 0 0 1px #f5222d inset",
          }}
        >
          <Popover
            trigger="hover"
            content={
              isError
                ? "Erro ao buscar histórico de valores"
                : "Histórico de valores"
            }
          >
            <Button
              type="primary"
              size="small"
              shape="circle"
              disabled={
                status === FetchStatus.LOADING ||
                status === FetchStatus.ERROR ||
                !data ||
                data.length === 0
              }
              loading={status === FetchStatus.LOADING}
              icon="history"
              onClick={handleOpen}
            />
          </Popover>
        </Badge>
      )}
      <Modal
        title="Histórico de valores"
        visible={open}
        closable
        onCancel={handleClose}
        footer={[
          <Button type="primary" onClick={handleClose}>
            Fechar
          </Button>,
        ]}
      >
        <div className="value_history__timeline">
          <Timeline>
            {isSuccess &&
              data &&
              data.length &&
              data.map((value) => (
                <Timeline.Item key={value.id}>
                  <span className="date">{format(value.dt_cadastro)} -</span>{" "}
                  Alterado de{" "}
                  <b>R$ {formatCurrency(value.valor_parcela_antigo)}</b> para{" "}
                  <b>R$ {formatCurrency(value.valor_parcela)}</b>
                </Timeline.Item>
              ))}
          </Timeline>
        </div>
      </Modal>
    </div>
  );
};

ValueHistory.propTypes = {
  id_parcela: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  parcela_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  visible: PropTypes.bool,
  onCancel: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/pages/Pasta/Contratos/Contrato/ValueHistory/index.jsx